module.exports = __webpack_public_path__ + "static/img/remote_work.462f67f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/remote_work.jpg
// module id = lFZ5
// module chunks = 1